import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { ToasterService } from '../../services/toaster.service';
import { DIALOG_DATA } from '../../../../global.variable';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ClientsService } from '../../../pages/pages/clients/clients.service';

@Component({
  selector: 'gtapp-select-monitoring-company',
  standalone: false,
  templateUrl: './select-monitoring-company.component.html',
  styleUrl: './select-monitoring-company.component.scss',
})
export class SelectMonitoringCompanyComponent implements OnInit, OnDestroy {
  selectedMonitoringCompany: any = {};
  selectedMonitoringCompanyBackup: any = {};

  monitoringCompanyListData: any = [];
  monitoringCompanyListDataBackup: any = [];

  monitoringCompanyStringValue: string = '';

  constructor(
    @Optional() protected dialogRef: DialogRef,
    private clientService: ClientsService,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.selectedMonitoringCompany =
      this.dialogueData?.selectedMonitoringCompany ||
      this.selectedMonitoringCompany;
    this.selectedMonitoringCompanyBackup = JSON.parse(
      JSON.stringify(this.selectedMonitoringCompany),
    );
    this.onMonitoringCompanyLookup();
  }
  onCloseDialogue(val: any = false) {
    this.dialogRef.close(val);
  }
  onSelectMonitoringCompany(monitoringCompanyData: any) {
    if (monitoringCompanyData?.id) {
      this.onCloseDialogue(monitoringCompanyData);
    }
    if (monitoringCompanyData?.key == 0) {
      if (!this.monitoringCompanyStringValue) {
        this.toasterService.setMessage({
          errorMessage: 'Monitoring Company Name cannot be empty!!!',
        });
        return;
      }
      this.clientService
        .createMonitoringCompany(
          { company_name: this.monitoringCompanyStringValue },
          {},
        )
        .then((resp: any) => {
          if (resp?.status != 'success') {
            this.toasterService.setMessage({ errorMessage: resp?.message });
            return;
          }
          this.onCloseDialogue(resp?.data);
        });
    }
  }
  editField() {
    this.shiftFocus('monitoringCompanyLookupFieldId');
    this.monitoringCompanyListData = JSON.parse(
      JSON.stringify(this.monitoringCompanyListDataBackup),
    );
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    });
  }
  onMonitoringCompanyLookup(event?: any) {
    const searchStr = event?.target?.value || '';
    const monitoringCompanyStringPresent = !!this.monitoringCompanyStringValue;
    this.monitoringCompanyStringValue = searchStr;

    if (monitoringCompanyStringPresent != !!this.monitoringCompanyStringValue) {
      this.monitoringCompanyListData = [...this.monitoringCompanyListData];
    }

    if (searchStr?.length > 3 || !searchStr) {
      let params: any = { search_str: searchStr };

      this.clientService
        .fetchMonitoringCompanyList(params)
        .subscribe((res: any) => {
          this.monitoringCompanyListData = res?.data || [];
          if (!searchStr)
            this.monitoringCompanyListDataBackup = res?.data || [];
        });
    }
  }
}
